<template>
	<StrapiTable v-bind="table">
		<BlockedIPsTableRow
			v-for="i in items"
			:key="i.ip"
			v-bind="i"
			:updating="updatingBlock === i.ip"
			@block="doBlock"
			@unblock="doUnblock"
		/>
	</StrapiTable>
</template>

<script>
import StrapiTable from '@/components/admin/StrapiTable'
import BlockedIPsTableRow from '@/components/admin/BlockedIPsTableRow'
import table from '@/mixins/table'
import tableBlocking from '@/mixins/tableBlocking'

const tableMixin = table([
	{ column: 'ip', label: 'IP Address' },
	{ column: 'blocked', label: 'Blocked', sort: 'DESC' },
	{ column: 'updated_at', label: 'Last update' },
	{ column: 'updatedBy', label: 'Updated by' },
	{ label: 'Actions' }
])

export default {
	name: 'BlockedIPsTable',
	mixins: [tableMixin, tableBlocking],
	components: {
		StrapiTable,
		BlockedIPsTableRow
	}
}
</script>
